<template>
  <div class="dashboard-table span-7 span-9-sm">
    <div class="table-header grid-12 grid-column-gap-0 border-bottom uppercase subheading-2 width-100">
      <div class="span-2 text-center">post</div>
      <div class="span-2 text-center">date</div>
      <div class="span-2 text-center">views</div>
      <div class="span-2">
        <span class="text-center">likes</span>
      </div>
      <div class="span-2">follows</div>
      <div />
    </div>
    <div v-if="posts.length" class="width-100">
      <div v-for="post in posts" :key="post.id">
        <table-row :post="post" />
      </div>
    </div>
    <div v-else class="p-20">no posts added!</div>
  </div>
</template>
<script>
import TableRow from "@/views/dashboard/posts/TableRow";

export default {
  name: "TableView",
  components: {
    TableRow,
  },
  props: ["posts"],
  mounted() {
    this.$ma.trackEvent({
      action: "Posts dashboard View",
      properties: {
        "view type": this.$options.name,
      },
    });
  },
  methods: {
    getUrl(url) {
      return url.replace("q=90,", "q=90,w=131,");
    },
  },
};
</script>
<style lang="scss">
.sidebar-wrapper #sidebar ul {
  border-right: 1px solid black;
}
</style>
